import { useThemeColor } from '@hooks/useThemeColor'
import { StatusBar } from 'expo-status-bar'
import { isDarkColor } from '../theme/color'

export function ThemedStatusBar() {
  const chrome = useThemeColor('bg-chrome')

  return <StatusBar style={isDarkColor(chrome) ? 'light' : 'dark'} />
}
